export default [
    {
        url: "/",
        name: "News",
        slug: "news",
        permission: null,
        icon: "FileTextIcon",
    },
];
